class ProductCardLanding extends HTMLElement {
    constructor() {
      super();
      this.handles = [];
      this.querySelectorAll(".product-swatch-landing").forEach((swatch) => {
        this.handles.push(swatch.getAttribute("data-handle"));
      });
      this.getAllProducts(this.handles);
    }
  
    updateProductCard(newHandle) {
      const product = this.getProductData(newHandle);
      if(this.querySelector('.product-swatch-landing').hasAttribute('data-url') && this.querySelector('.product-swatch-landing').getAttribute('data-url')) {
      }else{
        const domain = this.querySelector('.product-swatch-landing').getAttribute('data-domain');
      this.querySelector('.card-image-wrapper > a').href=`${domain}/products/${product.handle}`;
      this.querySelector('.card-information__wrapper-landing > a').href=`${domain}/products/${product.handle}`;
      
      this.updateProductCardPrice(product);
      }
      this.updateProductCardImg(product.media[1] ? product.media[1].src: product.featured_image, product.media[1] ? product.media[1].src : (product.media[0] ? product.media[0].src : ''), product.metafield_image);
      this.updateProductCardColor(product);
      
      this.updateProductSaleBadge(product);
      this.updateProductStockBadge(product.handle);
    }
    
    updateProductSaleBadge(product) {
        if(product.compare_at_price) {
        if(this.querySelector(".card__badge__landing")) this.querySelector(".card__badge__landing").innerHTML = '<span class="badge badge--bottom-left color-accent-2" aria-hidden="true">Sale</span>';
      } else {
        if(this.querySelector(".card__badge__landing")) this.querySelector(".card__badge__landing").innerHTML = '';
      }
    }
    
    updateProductStockBadge(product_handle) {
      fetch(`/products/${product_handle}?view=inventory`)
        .then(response => response.json())
        .then(data => {
          if(data.badge) {
            this.querySelector(".product_badge_landing").innerHTML = "Low Stock";
            this.querySelector(".product_badge_landing").style.display = 'block';
          } else {
            this.querySelector(".product_badge_landing").innerHTML = "";
            this.querySelector(".product_badge_landing").style.display = 'none';
          }
        });
    }
  
    updateProductCardImg(featuredSrc, secondarySrc,metafieldImage) {
      const featuredImg = this.querySelector(".featured-card-image-landing");
      const media = this.querySelector(".media-landing");
      const height = media.clientHeight;
      if(metafieldImage){
        featuredImg.srcset = metafieldImage;
      }else{
        if(featuredImg){
          featuredImg.srcset = featuredSrc;
        }
      }
    }
  
    updateProductCardColor(product) {
      const color = product.options.find((option) => option.name == "Color");
      this.querySelector('.card-information__text-landing').innerHTML = product.title;
      this.querySelectorAll(".product-color-landing").forEach(colorElement => {
        colorElement.textContent = color.values[0].split('+').join(', ');
      })
    }
  
    updateProductCardPrice(product) {
      if(product.compare_at_price) {
        if(this.querySelector(".price-item.price-item--sale")) this.querySelector(".price-item.price-item--sale").textContent = ' $' + (product.price / 100) + ' ';
        if(this.querySelector(".price-item.old-price")) this.querySelector(".price-item.old-price").textContent = ' $' + (product.compare_at_price / 100) + ' ';
        this.querySelector(".price .price__regular").style.display = "none";
        this.querySelector(".price .price__sale").style.display = "flex";
      } else {
        if(this.querySelector(".price-item--regular")) this.querySelector(".price-item--regular").textContent = ' $' + (product.price / 100) + ' ';
        this.querySelector(".price .price__sale").style.display = "block";
        this.querySelector(".price .price__regular").style.display = "none";
      }
    }
  
    getProductData(handle) {
      const scriptID = this.getAttribute("data-json-script-id");
      const metafieldsID = this.getAttribute("data-metafields-script-id");
      const data = JSON.parse(this.querySelector(`#${scriptID}`).textContent);
      const metafieldsData = JSON.parse(this.querySelector(`#${metafieldsID}`).textContent);
      const product = data.find((product) => product.handle === handle);
      const metafield = metafieldsData.find((metafield) => metafield.id === product.id);
      product.metafield_image =  typeof metafield !== "undefined" ? metafield.image: "";
      return product;
    }
  
    static get observedAttributes() {
      return ["data-selected-swatch"];
    }
  
    attributeChangedCallback(name, oldValue, newValue) {
      if (oldValue === null) return;
      this.updateProductCard(newValue);
    }
  
    storeRelatedProductsJSON(data) {
      const scriptID = this.getAttribute("data-json-script-id");
      const script = this.querySelector(`#${scriptID}`);
      script.textContent = JSON.stringify(data);
    }
  
    getAllProducts(handles) {
      const productPromises = [];
  
      for (let handle of handles) {
        productPromises.push(
          fetch(`/products/${handle}.js`)
            .then((response) => response.json())
            .then((data) => data)
            .catch((err) => {
              console.error(err);
            })
        );
      }
  
      Promise.allSettled(productPromises).then((results) => {
        const products = [];
        results.forEach((result) => {
          if (result.status === "fulfilled") products.push(result.value);
        });
        this.storeRelatedProductsJSON(products);
      });
    }
  }
  
  customElements.define("product-card-landing", ProductCardLanding);
  
  class QuickAddLanding extends HTMLElement {
    constructor() {
      super();
      this.querySelectorAll(".quick-add-option-value-landing").forEach((option) => {
        option.addEventListener("click", this.handleOptionChange.bind(this));
      });
      this.optionsToSelect = this.querySelectorAll(".quick-add-option-landing").length;
      this.selectedOptions = 0;
  
      window.addEventListener('load', () => {
        this.querySelectorAll('.ds-stretch-fit.skinny .quick-add-option-values-landing[data-option-name="Inseam"] span').forEach((option)=>{
          if(option.innerHTML == 32) {
            option.click()
          }
        })
        setTimeout(() => {
          if(this.optionsToSelect == 1) {
            this.querySelectorAll(".quick-add-option-value-landing").forEach((option) => {
              const handle = this.selectedProductHandle;
              const products = JSON.parse(
                option.closest("product-card-landing").querySelector("script").textContent
              );
              const selectedProduct = products.find((data) => data.handle === handle);
  
              const product = selectedProduct;
              const position = option.parentElement.getAttribute("data-option-position");
              const value = option.textContent;
              const filterOptionPosition = position;
  
  
              const availableOptions = product.variants
                .filter((variant) => variant[position] == value && variant.available)
                .map((variant) => variant[filterOptionPosition]);
  
              availableOptions.includes(option.textContent)
                ? option.classList.remove("unavailable")
                : option.classList.add("unavailable");
            });
          }
        },1000);
      });
    }
  
    static get observedAttributes() {
      return ["data-selected-swatch"];
    }
  
    get selectedProductHandle() {
      return this.getAttribute("data-selected-swatch");
    }
  
    renderNewOptions() {
      const selectedProduct = this.getSelectedProduct();
      this.selectedOptions = 0;
      selectedProduct.options.forEach((option) => {
        if (option.name !== "Color") {
          const optionsContainer = this.querySelector(
            `[data-option-name="${option.name}"]`
          );
          const newOptions = [];
          option.values.forEach((value) => {
            const option = document.createElement("span");
            option.classList.add("quick-add-option-value-landing");
            option.textContent = value;
            option.addEventListener("click", this.handleOptionChange.bind(this));
            newOptions.push(option);
          });
          optionsContainer.replaceChildren(...newOptions);
        }
      });
    }
  
    attributeChangedCallback(name, oldValue, newValue) {
      if (oldValue === null) return;
      this.renderNewOptions();
    }
  
    getSelectedProduct() {
      const handle = this.selectedProductHandle;
      const products = JSON.parse(
        this.closest("product-card-landing").querySelector("script").textContent
      );
      const selectedProduct = products.find((data) => data.handle === handle);
      return selectedProduct;
    }
  
    showAvailableOptions(option) {
      const product = this.getSelectedProduct(option);
      const position = option.parentElement.getAttribute("data-option-position");
      const value = option.textContent;
      const filterOptionPosition = position === "option2" ? "option3" : "option2";
  
      const availableOptions = product.variants
        .filter((variant) => variant[position] == value && variant.available)
        .map((variant) => variant[filterOptionPosition]);
  
      if (!option.classList.contains("selected")) {
        return this.querySelectorAll(
          `[data-option-position="${filterOptionPosition}"] .quick-add-option-value-landing`
        ).forEach((option) => {
          option.classList.remove("unavailable");
        });
      }
  
      this.querySelectorAll(
        `[data-option-position="${filterOptionPosition}"] .quick-add-option-value`
      ).forEach((option) => {
        availableOptions.includes(option.textContent)
          ? option.classList.remove("unavailable")
          : option.classList.add("unavailable");
      });
    }
  
    getSelectedProductID() {
      const options = [];
      this.querySelectorAll(".selected").forEach((option) => {
        options.push(option.textContent);
      });
  
      const optionsTitle = options.join(" / ");
      const product = this.getSelectedProduct();
  
      const selectedVariant = product.variants.find((variant) =>
        variant.title.includes(` ${optionsTitle}`)
      );
  
      return selectedVariant.id;
    }
  
    getProductFinalSaleBage() {
      const product = this.getSelectedProduct();
      let finalSale = false;
      if(product.tags.includes('mens-final-sale') || product.tags.includes('womens-final-sale'))
        finalSale = true;
      return finalSale;
    }
  
    addProductToCart() {
      const id = this.getSelectedProductID();
      const finalSale = this.getProductFinalSaleBage();
      const finalSaleProps = finalSale ? { _final_sale: 'yes' } : { _final_sale: 'no' };
      const sideCart = document.querySelector("side-cart");
  
      new Promise((resolve, reject) => {
        resolve(sideCart.addToCart(id, 1, finalSaleProps));
      }).then(() => {
        document.querySelector('.loader').classList.remove('show');
        sideCart.openCart();
        this.renderNewOptions();
      });
    }
  
    handleOptionChange(e) {
      const option = e.target;
      const prevSelectedOption = option.parentElement.querySelector(".selected");
      if (prevSelectedOption) {
        prevSelectedOption.classList.remove("selected");
        --this.selectedOptions;
      }
  
      if (!option.isEqualNode(prevSelectedOption)) {
        option.classList.add("selected");
        ++this.selectedOptions;
      }
  
      this.showAvailableOptions(option);
  
      if (this.selectedOptions === this.optionsToSelect) {
        if(this.constructor.name === 'MobileQuickAdd') {
          this.querySelector('.mobile-quick-add-options__wrapper').classList.remove('open');
          this.querySelector('.mobile-quick-add-btn-landing').classList.remove('open');
        }
        document.querySelector('.loader').classList.add('show');
        return this.addProductToCart();
      }
    }
  }
  
  customElements.define("quick-add-landing", QuickAddLanding);
  
  class MobileQuickAddLanding extends QuickAddLanding {
    constructor() {
      super();
      if(this.querySelector(".mobile-quick-add-btn-landing")){
        this.querySelector(".mobile-quick-add-btn-landing").addEventListener(
          "click",
          this.showMobileOptions.bind(this)
        );
      }
    }
  
    showMobileOptions(e) {
      document.querySelectorAll('mobile-quick-add .mobile-quick-add-options__wrapper').forEach((el) => {
        if(el != e.target.previousElementSibling)
          el.classList.remove('open');
      })
      document.querySelectorAll('mobile-quick-add .mobile-quick-add-btn-landing').forEach((el) => {
        if(el != e.target)
          el.classList.remove('open');
      });
      const mobileOptions = e.target.previousElementSibling;
      e.target.classList.toggle("open");
      mobileOptions.classList.toggle("open");
    }
  }
  
  customElements.define("mobile-quick-add-landing", MobileQuickAddLanding);
  
  class ProductSwatchLanding extends HTMLElement {
    constructor() {
      super();
      this.swatches = this.querySelectorAll(".product-swatch-landing");
      this.swatches.forEach((swatch) => {
        swatch.addEventListener("click", this.handleSwatchChange.bind(this));
      });
    }
  
    connectedCallback() {
      let swatch = this.querySelectorAll('.product-swatch-landing')[0].querySelector('.swatch-color');
      this.handleSwatchChange();
    }
    
    updateSelectedSwatchClass(targetSwatch) {
      this.swatches.forEach((swatch) => {
        swatch.classList.remove("swatch-selected");
      });
  
      targetSwatch.classList.add("swatch-selected");
    }
  
    get selectedProductHandle() {
      return this.closest("product-card-landing").querySelector('quick-add-landing').getAttribute("data-selected-swatch");
    }
  
    updateAttributes(handle) {
      const productCard = this.closest("product-card-landing");
      const quickAdd = productCard.querySelector("quick-add-landing");
      const mobileQuickAdd = productCard.querySelector("mobile-quick-add-landing");
      productCard.setAttribute("data-selected-swatch", handle);
      quickAdd.setAttribute("data-selected-swatch", handle);
      mobileQuickAdd.setAttribute("data-selected-swatch", handle);
  
      if(quickAdd.querySelectorAll('.quick-add-option-landing').length == 1) {
        productCard.querySelectorAll(".quick-add-option-value").forEach((option) => {
          const handle = this.selectedProductHandle;
          const products = JSON.parse(
            option.closest("product-card-landing").querySelector("script").textContent
          );
          const selectedProduct = products.find((data) => data.handle === handle);
  
          const product = selectedProduct;
          const position = option.parentElement.getAttribute("data-option-position");
          const value = option.textContent;
          const filterOptionPosition = position;
  
  
          const availableOptions = product.variants
            .filter((variant) => variant[position] == value && variant.available)
            .map((variant) => variant[filterOptionPosition]);
  
          availableOptions.includes(option.textContent)
            ? option.classList.remove("unavailable")
            : option.classList.add("unavailable");
        });
      }
    }
  
    handleSwatchChange(e) {
      let swatch = '';
      if(!e) {
        swatch = this.querySelector(".product-swatch-landing");  
      }else {
        swatch = e.target.closest(".product-swatch-landing");
      }
      const handle = swatch.getAttribute("data-handle");
      let newURL = swatch.getAttribute('data-url');
      if(newURL) {
        let links = this.parentNode.parentNode.parentNode.querySelectorAll('a');
        const domain = this.querySelector('.product-swatch-landing').getAttribute('data-domain');
        newURL = domain + newURL;
        links.forEach(l => {
          l.href = newURL;
        });
      }
      if (swatch.classList.contains("swatch-selected")) return;
  
      this.updateSelectedSwatchClass(swatch);
      this.updateAttributes(handle);
    }
  }
  
  customElements.define("product-swatch-landing", ProductSwatchLanding);
  